<template>
  <div v-if="this.params">
    <b-form-checkbox class="mt-2" v-model="includeRegardlessOfValues" @change="setIncludeRegardlessOfValues()"></b-form-checkbox>
  </div>
</template>

<script>
import VwTapService from '@/services/VwTapService'

export default {
  name: "IncludeRegardlessOfValuesCellRenderer",
  data() {
    return {
      includeRegardlessOfValues: null
    }
  },
  created() {
    this.includeRegardlessOfValues = this.params.value;
  },
  methods: {
    setIncludeRegardlessOfValues() {
      setTimeout(() => {
        VwTapService.setIncludeRegardlessOfValues(this.params.data.SurveyInstanceId, this.includeRegardlessOfValues);
      }, 500);
    }
  },
}
</script>

<style>

</style>